import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContinueToNextViewButton } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ContinueToNextViewButton";
import { convertErrorToLoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/convertErrorToLoginError";
import { MFAOptionsView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/EmailSentWaitingView";
import { RadioMFAOption } from "@faire/retailer-visitor-shared/components/AppSignIn/components/RadioMFAOption";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { useSettingMFAExperienceXP } from "@faire/retailer-visitor-shared/settings/useSettingSignInImprovements";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import login from "@faire/web-api--source/api/v2/users/login/post";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { LoginState } from "@faire/web-api--source/indigofair/data/LoginState";
import { MfaMethod } from "@faire/web-api--source/indigofair/data/MfaMethod";
import React, { useState, useMemo } from "react";
import styled from "styled-components";
export var SelectMFAOptionView = function(param) {
    var email = param.email, mfaOptions = param.mfaOptions, userToken = param.userToken, password = param.password, onComplete = param.onComplete, onLogin = param.onLogin, isMFAFromEmail = param.isMFAFromEmail, mfaTitle = param.mfaTitle, mfaDescription = param.mfaDescription;
    var _mfaOptionsMemoized_;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isMobile = useViewport().isMobile;
    var mfaOptionsMemoized = useMemo(function() {
        if (isMobile) {
            // Move SMS MFA Method to front
            var mfaMethod = MfaMethod.SMS;
            if (!mfaOptions.some(function(option) {
                return option.method === mfaMethod;
            })) {
                return mfaOptions;
            }
            var mfaMethodIndex = mfaOptions.findIndex(function(option) {
                return option.method === mfaMethod;
            });
            var updatedMfaOptions = mfaOptions.slice();
            var _updatedMfaOptions_splice = _sliced_to_array(updatedMfaOptions.splice(mfaMethodIndex, 1), 1), mfaOptionToMove = _updatedMfaOptions_splice[0];
            if (mfaOptionToMove) {
                updatedMfaOptions.unshift(mfaOptionToMove);
            }
            return updatedMfaOptions;
        }
        return mfaOptions;
    }, [
        isMobile,
        mfaOptions
    ]);
    var _useState = _sliced_to_array(useState(mfaOptionsMemoized === null || mfaOptionsMemoized === void 0 ? void 0 : (_mfaOptionsMemoized_ = mfaOptionsMemoized[0]) === null || _mfaOptionsMemoized_ === void 0 ? void 0 : _mfaOptionsMemoized_.method), 2), mfaOption = _useState[0], setMfaOption = _useState[1];
    var settingMFAExperienceXP = useSettingMFAExperienceXP();
    var _useSSOStore = useSSOStore(), isActive = _useSSOStore.isActive, ssoToken = _useSSOStore.ssoToken;
    var onContinue = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var request, _ref, mfa_description, mfa_title, login_state, user, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        request = isActive ? ILoginRequest.build({
                            mfa_method: mfaOption,
                            sso_token: ssoToken,
                            password: password,
                            enable_mfa_method_selection: true
                        }) : ILoginRequest.build({
                            password: password,
                            email_address: email,
                            user_token: !email ? userToken : undefined,
                            mfa_method: mfaOption,
                            enable_mfa_method_selection: true
                        });
                        return [
                            4,
                            login(request)
                        ];
                    case 1:
                        _ref = _state.sent(), mfa_description = _ref.mfa_description, mfa_title = _ref.mfa_title, login_state = _ref.login_state, user = _ref.user;
                        if (login_state === LoginState.MFA_REQUIRED) {
                            onComplete({
                                nextView: View.ENTER_MFA,
                                mfaDescription: mfa_description,
                                mfaTitle: mfa_title,
                                mfaMethod: mfaOption,
                                isMFAFromEmail: isMFAFromEmail
                            });
                            return [
                                2
                            ];
                        }
                        onComplete({
                            nextView: View.LOADING
                        });
                        if (user) {
                            onLogin(user);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        throw convertErrorToLoginError(e, strictLocalize);
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onContinue() {
            return _ref.apply(this, arguments);
        };
    }();
    if (settingMFAExperienceXP) {
        return /*#__PURE__*/ _jsx(MFAOptionsView, {
            email: email,
            mfaTitle: mfaTitle,
            mfaDescription: mfaDescription,
            password: password,
            userToken: userToken,
            mfaOptionsMemoized: mfaOptionsMemoized,
            onComplete: onComplete
        });
    }
    return /*#__PURE__*/ _jsxs(LoginWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displaySSerifRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "INjXDu",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Verify it\u2019s you"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "f0BZyj",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "To keep your account safe, we want to make sure it\u2019s really you. How would you like to receive your verification code?"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(RadioMFAWrapper, {
                children: mfaOptionsMemoized.map(function(param) {
                    var method = param.method, name = param.name, value = param.value;
                    return method !== MfaMethod.MFA_METHOD_UNKNOWN ? /*#__PURE__*/ _jsx(Row, {
                        children: /*#__PURE__*/ _jsx(RadioMFAOption, {
                            active: mfaOption === method,
                            title: name,
                            value: value,
                            onClick: function() {
                                return setMfaOption(method);
                            }
                        })
                    }, method) : null;
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(Continue, {
                onClick: onContinue,
                disabled: !mfaOption
            })
        ]
    });
};
var Continue = styled(ContinueToNextViewButton).withConfig({
    componentId: "sc-d970ecd4-0"
})([
    "width:100%;"
]);
var RadioMFAWrapper = styled(Column).attrs({
    gap: "2x"
}).withConfig({
    componentId: "sc-d970ecd4-1"
})([
    ""
]);
